import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { fadeUp, viewportOnce } from "../lib/motion";

const PricingCta = () => (
    <section
        data-testid="pricing-cta"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex flex-col items-start gap-10 md:flex-row md:items-center md:justify-between"
            >
                <div>
                    <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                        GET STARTED
                    </p>
                    <p className="mt-4 max-w-md text-2xl font-light leading-snug text-white md:text-3xl">
                        One project. One payment.
                        <span className="text-mist"> Start with yours.</span>
                    </p>
                </div>
                <Link
                    to="/join-the-pilot"
                    data-testid="pricing-join-pilot"
                    className="inline-flex items-center gap-3 bg-accent px-9 py-5 text-[16px] font-semibold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#ff7026]"
                >
                    JOIN THE PILOT
                    <ArrowUpRight className="h-4 w-4" />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default PricingCta;
